import { MenuAction } from '@reducers/menuReducer'
import { Dispatch } from 'react'
import { ErrorCodes, ErrorActions } from '@constants/index'
import { ErrorAction, setError } from './errorCodeActions'
import { setSkeleton } from './skeletonActions'
import { SkeletonAction } from '@reducers/skeletonReducer'
import { RootState } from 'store'
import { VelvetSDK } from 'sdk'
import { MenuDataType } from 'sdk/services/cms/types/cmsService'
export const SET_OPEN_MENU = 'SET_OPEN_MENU'

export const setOpenMenu = (openMenu: boolean) => ({
  type: SET_OPEN_MENU,
  payload: {
    openMenu,
  },
})

export const FETCH_MENU_REQUEST = 'FETCH_MENU_REQUEST' as const
export const FETCH_MENU_SUCCESS = 'FETCH_MENU_SUCCESS' as const
export const FETCH_MENU_FAILURE = 'FETCH_MENU_FAILURE' as const

export const fetchMenuRequest = () => ({ type: FETCH_MENU_REQUEST })

export const fetchMenuSuccess = (menu: MenuDataType) => ({
  type: FETCH_MENU_SUCCESS,
  payload: menu,
})

export const fetchMenuFailure = (error: string) => ({
  type: FETCH_MENU_FAILURE,
  payload: error,
})

export const fetchMenu = (language?: string) => {
  return async (dispatch: Dispatch<MenuAction | ErrorAction | SkeletonAction>, getState: () => RootState) => {
    dispatch(fetchMenuRequest())
    dispatch(setSkeleton(true))
    const userCountry = getState().userCountry.data.countryCode
    const menuData = await VelvetSDK.CMS.service().fetchMenu(language, userCountry)
    const errorFetchAction = getState().errorCode?.fetchAction
    if (!menuData.error) {
      dispatch(fetchMenuSuccess(menuData))
      dispatch(setSkeleton(false))
      dispatch(setOpenMenu(false))
      errorFetchAction === ErrorActions.MENU && dispatch(setError({ errorCode: '', showErrorModal: false }))
    } else {
      const errorMsg = menuData.error.message
      const errorUpdate = {
        showErrorModal: true,
        errorCode: ErrorCodes.FETCH_MENU_ITEMS,
        HTTPcode: menuData.error.status,
        fetchAction: ErrorActions.MENU,
      }
      dispatch(fetchMenuFailure(errorMsg))
      dispatch(setError(errorUpdate))
    }
  }
}
